module.exports = __webpack_public_path__ + "static/media/icon-user-group.3755fcc9.svg";